import React, { Component } from 'react';

import ProjectDisplay from './ProjectDisplay';
import ProjectInfo from './ProjectInfo';
import ScrollToNextButton from './ScrollToNextButton';

import { cloudinaryResizeURL, cloudinarySrcSet } from '../util/cloudinaryImageUtil'

const bpWidths = {
  mobile: 400,
  tablet: 800,
  desktop: 1200
};

function optimizeImages(imgArr, clientWidth, breakpoint) {
  // image max width is scaled to client width or breakpoint, whichever is greater?
  const bpWidth = bpWidths[breakpoint];
  if (clientWidth > bpWidth) {
    return imgArr.map(img => {
      if (typeof img !== 'object') {
        return {
          src: cloudinaryResizeURL(img, bpWidth),
          srcset: cloudinarySrcSet(img, bpWidths)
        }
      } else return img;
    });
  } else if (clientWidth <= bpWidth) {
    return imgArr.map(img => {
      if (typeof img !== 'object') {
        return {
          src: cloudinaryResizeURL(img, clientWidth),
          srcset: cloudinarySrcSet(img, bpWidths)
        }
      } else return img;
    });
  } else return imgArr;
}

class ProjectComponent extends Component {

  constructor(props) {
    super(props);

    this.handleDisplayNavClick = this.handleDisplayNavClick.bind(this);
    this.handleToolbarSwitchClick = this.handleToolbarSwitchClick.bind(this);

    this.state = {
      image: '',
      images: [],
      breakpoint: '', // string: 'mobile', 'tablet', or 'desktop'
      // displayIdx: 0
    };

    const images = props.project.images;
    if (images) {
      const bp_avail = {};
      const clientWidth = document.body.clientWidth;

      // set default breakpoint
      let breakpoint = '';
      // TO-DO: write Object.entries loop for below

      if (images.mobile && images.mobile.length > 0) {
        if (!breakpoint) breakpoint = 'mobile';
        bp_avail.mobile = true;
        images.mobile = optimizeImages(images.mobile, clientWidth, 'mobile');
      }
      if (images.tablet && images.tablet.length > 0) {
        if (!breakpoint) breakpoint = 'tablet';
        bp_avail.tablet = true;
        images.tablet = optimizeImages(images.tablet, clientWidth, 'tablet');
      }
      if (images.desktop && images.desktop.length > 0) {
        if (!breakpoint) breakpoint = 'desktop';
        bp_avail.desktop = true;
        images.desktop = optimizeImages(images.desktop, clientWidth, 'desktop');
      }

      if (breakpoint) {
        this.state = {
          images,
          breakpoint,
          bp_avail,
          bp_image: images[breakpoint][0],
          bp_images: images[breakpoint]
        }
      }
    }
    // TO-DO: get breakpoint based on client width and set default image to first img from that breakpoint (if those images exist)
  }

  componentWillMount() {
    //TO-DO: optimize image width before loading them with cloudinaryImageUtil
    // if this.state.images

    // console.log('project will mount, document width:', document.body.clientWidth);

    // add resize eventlistener for project display
    // USE --> http://marcj.github.io/css-element-queries/

    // resize changes this.images, this.breakpoint, and this.image if breakpoint triggered
  }

  componentWillUnmount() {
    // remove resize eventlistener
  }

  handleDisplayNavClick(e) {
    // const idx = parseInt(e.currentTarget.getAttribute('data-key'), 10);
    // console.log(e, idx)
    this.setState({
      // displayIdx: idx,
    });
  }

  //TO-DO: fix toolbar switch CSS when there are only 2 breakpoints available
  handleToolbarSwitchClick(breakpoint) {
    
    // console.log(this.state);
    const bp_images = this.state.images[breakpoint];
    this.setState({
      // displayIdx: idx,
      breakpoint,
      bp_images,
      bp_image: this.state.images[breakpoint][0],
    });
  }

  render() {
    // test template with image nav removed
    // return (
    //   <div className="project-container" style={bgStyle}>
    //     {this.props.heading && <h1>{this.props.heading}</h1>}
    //     <div className="project-content">
    //       {(this.props.project.images !== null) &&
    //         <ProjectDisplay pid={this.props.pid} title={this.props.project.title} image="" />
    //       }
    //       <ProjectInfo project={this.props.project} />
    //     </div>
    //     {this.props.nextNav && <ScrollToNextButton color="black"></ScrollToNextButton>}
    //   </div>
    // );

    // actual template without image nav
    return (
      <div className="project-container">
        {this.props.heading && <h1>{this.props.heading}</h1>}
        <div className="project-content">
        {(this.state.bp_images && this.state.bp_images.length > 0) &&
            <ProjectDisplay pid={this.props.pid}
                title={this.props.project.title}
                image={this.state.bp_image}
                breakpoint={this.state.breakpoint}
                breakpoints={this.state.bp_avail}
                onToolbarSwitchClick={this.handleToolbarSwitchClick} />
        }
        <ProjectInfo project={this.props.project} />
        </div>
        {this.props.nextNav && <ScrollToNextButton color="white"></ScrollToNextButton>}
      </div>
    );

    // old test template
    // return (
    //   <div className="project-container" style={bgStyle}>
    //     {this.props.heading && <h1>{this.props.heading}</h1>}
    //     <div className="project-content">
    //       {(this.props.project.images !== null) &&
    //         <ProjectDisplay pid={this.props.pid} title={this.props.project.title} image="" />
    //       }
    //       {(this.props.project.images !== null) && (
    //         <nav className="project-display-nav">
    //           <li className={0 === this.state.displayIdx ? "active" : ""} data-key="0" onClick={this.handleDisplayNavClick}></li>
    //           <li className={1 === this.state.displayIdx ? "active" : ""} data-key="1" onClick={this.handleDisplayNavClick}></li>
    //           <li className={2 === this.state.displayIdx ? "active" : ""} data-key="2" onClick={this.handleDisplayNavClick}></li>
    //         </nav>
    //       )}
    //       <ProjectInfo project={this.props.project} />
    //     </div>
    //     {this.props.nextNav && <ScrollToNextButton color="black"></ScrollToNextButton>}
    //   </div>
    // );

    // actual template
    // return (
    //   <div className="project-container">
    //     {(this.state.images && this.state.images.length > 0) &&
    //         <ProjectDisplay pid={this.props.pid} title={this.props.project.title} image={this.state.image} />
    //     }
    //     {(this.state.images && this.state.images.length > 1) &&
    //       <nav className="project-display-nav">
    //         {this.state.images.map((img, idx) => 
    //           <li key={idx} onClick={this.handleDisplayNavClick} className={idx === this.state.displayIdx ? "active" : ""}></li>
    //         )}
    //       </nav>
    //     }
    //     <ProjectInfo project={this.props.project} />
    //   </div>
    // );
  }

}

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/components/ProjectComponent.js